import {SiteContentValues} from "../models/SiteContent";

// THE single source of truth for the homepage hero copy.
// The backend never fabricates defaults - it returns `content: null` until an
// admin publishes, and the hero renders these values synchronously either way.
const homeContentDefaults: SiteContentValues = {
    hero: {
        // Rendered line by line; every line after the first gets the accent color.
        title: "קישורים חזקים\nלקידום אתרים",
        subtitle: "אתרים איכותיים, כתיבה מקצועית\nוליווי אישי — הכל במקום אחד.",
        ctaPrimaryLabel: "הצטרפות חינם",
        ctaSecondaryLabel: "לצפייה באתרים",
    },
    // Order matters - stats[0..2] map to the three floating badges in that order.
    stats: [
        {value: "400+", label: "אתרים זמינים"},
        {value: "150%+", label: "כניסות לאתר"},
        {value: "100%", label: "תוכן אורגני"},
    ],
    // enabled stays false here on purpose: the bar may only ever appear because
    // an admin published it, never because the shipped defaults said so.
    announcement: {
        text: "AI Mentions — הופיעו בתשובות של ChatGPT, Gemini ו-Claude.",
        enabled: false,
    },
};

export default homeContentDefaults;
